export default __webpack_public_path__ + "static/media/logo.eba165e4.png";